import { AnalyticsPurchaseItem } from '../utils/getAnalyticsItems'

export enum GTMEventNames {
  PURCHASE = 'commerce-purchase',
  VIEW_ITEM = 'commerce-view_item',
  ADD_TO_CART = 'commerce-add_to_cart',
  REMOVE_FROM_CART = 'commerce-remove_from_cart',
  VIEW_CART = 'commerce-view_cart',
}

export enum ItemListNames {
  CATALOG = 'catalog',
  CART = 'cart',
  SEARCH_RESULTS = 'search_results',
  RECOMMENDATIONS_CAROUSEL = 'recommendations_carousel',
  RECOMMENDATIONS_LIST = 'recommendations_list',
  BANNER = 'banner',
}

export interface IPurchaseParams {
  currency: string
  value: number
  items: AnalyticsPurchaseItem[]
  transaction_id: string
}

export interface IViewItemParams {
  value: number
  currency: string
  items: AnalyticsPurchaseItem[]
}

export interface IAddToCartParams {
  currency: string
  value: number
  items: AnalyticsPurchaseItem[]
}

export interface IRemoveFromCartParams {
  currency: string
  value: number
  items: AnalyticsPurchaseItem[]
}

export interface IViewCartParams {
  currency: string
  value: number
  items: AnalyticsPurchaseItem[]
}

export type GTMEventParams = {
  [GTMEventNames.PURCHASE]: IPurchaseParams
  [GTMEventNames.VIEW_ITEM]: IViewItemParams
  [GTMEventNames.ADD_TO_CART]: IAddToCartParams
  [GTMEventNames.REMOVE_FROM_CART]: IRemoveFromCartParams
  [GTMEventNames.VIEW_CART]: IViewCartParams
}
